import { render, staticRenderFns } from "./SIS_ProgrammeList.vue?vue&type=template&id=53ff3189&"
import script from "./SIS_ProgrammeList.vue?vue&type=script&lang=ts&"
export * from "./SIS_ProgrammeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports